import Accordion from 'accordion-js';
import { document } from 'postcss';

new Accordion('.accordion-container-first', {
  openOnInit: [0],
});
